/**
 * 路由配置文件
 * 懒加载: const Foo = () => import('./Foo.vue')
 * 嵌套路由：https://router.vuejs.org/zh/guide/essentials/nested-routes.html
 * 编程式导航：https://router.vuejs.org/zh/guide/essentials/navigation.html
 * 路由元信息：https://router.vuejs.org/zh/guide/advanced/meta.html
 */

import Vue from 'vue'
import Router from 'vue-router'

const Dashboard = () => import(/* webpackChunkName: "group-test" */ '@/pages/general/Dashboard')
const Categories = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Categories')
const Sliders = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Sliders')
const Brands = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Brands')
const Countries = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Countries')
const Banner = () => import(/* webpackChunkName: "group-general" */ '@/pages/shop/Banner')
const Brand = () => import(/* webpackChunkName: "group-general" */ '@/pages/shop/Brand')
const Goods = () => import(/* webpackChunkName: "group-general" */ '@/pages/goods/Goods')
const Records = () => import(/* webpackChunkName: "group-general" */ '@/pages/goods/Records')
const Messaging = () => import(/* webpackChunkName: "group-general" */ '@/pages/shop/Messaging')
const LocalMessaging = () => import(/* webpackChunkName: "group-general" */ '@/pages/shop/LocalMessaging')
const branches = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/branches')
const Order = () => import(/* webpackChunkName: "group-general" */ '@/pages/order/Order')
const Users = () => import(/* webpackChunkName: "group-user" */ '@/pages/user/Users')
const BuyerInformation = () => import(/* webpackChunkName: "group-shop" */ '@/pages/user/BuyerInformation')
const Settled = () => import(/* webpackChunkName: "group-shop" */ '@/pages/user/Settled')
const OrdersAll = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersAll')
const OrdersSend = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersSend')
const OrdersWaiting = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersWaiting')
const OrdersWaitingCross = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersWaitingCross')
const OrdersPayment = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersPayment')
const OrdersCart = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersCart')
const OrdersPay = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersPay')
const OrdersFinish = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersFinish')
const OrdersFail = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersFail')
const Bankinfo = () => import(/* webpackChunkName: "group-order" */ '@/pages/shop/Bankinfo')
// 平台公章 CommonSeal
const CommonSeal = () => import(/* webpackChunkName: "group-shop" */ '@/pages/user/CommonSeal')

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Dashboard', component: Dashboard },
    { path: '/categories', name: 'Categories', component: Categories },
    { path: '/sliders', name: 'Sliders', component: Sliders },
    { path: '/brands', name: 'Brands', component: Brands },
    { path: '/countries', name: 'Countries', component: Countries },

    { path: '/BuyerInformation', name: 'BuyerInformation', component: BuyerInformation },
    { path: '/Settled', name: 'Settled', component: Settled },
    { path: '/banner', name: 'Banner', component: Banner },
    { path: '/brand', name: 'Banner', component: Brand },
    { path: '/goods', name: 'Goods', component: Goods },
    { path: '/records', name: 'Records', component: Records },
    { path: '/messaging', name: 'Messaging', component: Messaging },
    { path: '/LocalMessaging', name: 'LocalMessaging', component: LocalMessaging },
    { path: '/branches', name: 'branches', component: branches },
    { path: '/users', name: 'Users', component: Users },
    { path: '/ordersAll', name: 'OrdersAll', component: OrdersAll },
    { path: '/ordersSend', name: 'OrdersSend', component: OrdersSend },
    { path: '/ordersWaiting', name: 'OrdersWaiting', component: OrdersWaiting },
    { path: '/OrdersWaitingCross', name: 'OrdersWaitingCross', component: OrdersWaitingCross },
    { path: '/ordersPayment', name: 'OrdersPayment', component: OrdersPayment },
    { path: '/OrdersPay', name: 'OrdersPay', component: OrdersPay },
    { path: '/ordersCart', name: 'OrdersCart', component: OrdersCart },
    { path: '/ordersFinish', name: 'OrdersFinish', component: OrdersFinish },
    { path: '/ordersFail', name: 'OrdersFail', component: OrdersFail },
    { path: '/bankinfo', name: 'Bankinfo', component: Bankinfo },
    { path: '/order', name: 'Order', component: Order },
    // 平台公章 CommonSeal
    { path: '/commonSeal', name: 'CommonSeal', component: CommonSeal }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js